import { useEffect, useState } from "react";
import { navItems } from "@/mocks/siteContent";

export default function HomeNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("ranking");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      let current = "";
      navItems.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 150) {
          current = item.id;
        }
      });
      if (current) setActive(current);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "border-b border-background-300/70 bg-background-50/95 backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="flex h-[68px] w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5" onClick={() => setMenuOpen(false)}>
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className={`font-heading text-lg tracking-wide ${solid ? "text-foreground-950" : "text-background-50"}`}>
            伦理片在线观看
          </span>
        </a>

        <nav className="hidden items-center gap-0.5 lg:flex" aria-label="页面分区导航">
          {navItems.map((item) => {
            const isActive = active === item.id && solid;
            return (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  solid
                    ? isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                    : "text-background-50/90 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#ranking"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors md:inline-flex ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            查看榜单
          </a>
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              solid ? "text-foreground-950 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-300/70 bg-background-50 lg:hidden">
          <nav className="grid grid-cols-2 gap-1 px-4 py-3" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}